import { AuthenticationData } from '../store/authentication';
import { Offers } from '../types/OfferTypes';
import { apiClient } from './apiClient';

export const getSelectedOffers = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string,
    authenticationData?: AuthenticationData,
): Promise<Offers> => {
    return apiClient<Offers>(`${proxyBaseUrl}/offers/${arn}`, {
        method: 'GET',
        apiKey,
        authenticationData,
        sentryTag: 'get_selected_offers',
        sentryExtra: { arn },
    });
};
